import React from 'react';

const NuevoEditarForm = () => {
    return <>NuevoEditarForm</>;
};

export default NuevoEditarForm;
